import { create } from "zustand";

type StripePortalRedirectStore = {
  isRedirecting: boolean;
  startRedirect: () => boolean; // returns true if lock acquired
  endRedirect: () => void;
};

/**
 * Only allow one Stripe redirect to occur at a time.
 */
export const useStripePortalRedirectStore = create<StripePortalRedirectStore>(
  (set, get) => ({
    isRedirecting: false,
    startRedirect: () => {
      if (get().isRedirecting) {
        return false;
      }
      set({ isRedirecting: true });
      return true;
    },
    endRedirect: () => set({ isRedirecting: false }),
  }),
);
